import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  Heading,
  FilterSelect,
  SkeletonLoader,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import VerticalListDisplay from '@/modules/wealth/components/PerformanceHeader/components/VerticalListDisplay/VerticalListDisplay.vue';
import { IChartSummary } from '@/modules/catalog/types/chart';
import {
  IProductBenchmark,
  IProductPeriod
} from '@/modules/catalog/services/products';

interface Props {
  isLoading: boolean;
  hasError: boolean;
  chartSummary?: IChartSummary;
  periodFilters: IProductPeriod[];
  benchmarkFilters: IProductBenchmark[];
  profitLabel?: string;
  returnLabel?: string;
}
interface Emits {
  (e: 'on-period-filter-change', value: string): void;
  (e: 'on-benchmark-filter-change', value: string): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPerformanceHeader',
  props: {
    isLoading: { type: Boolean },
    hasError: { type: Boolean },
    chartSummary: { default: () => ({
    benchmarkReturn: { value: 0, formatted: '0' },
    percentageValue: { value: 0, formatted: '0' },
    benchmarkComparison: { value: 0, formatted: '0' }
  }) },
    periodFilters: null,
    benchmarkFilters: null,
    profitLabel: { default: 'Rendimento' },
    returnLabel: { default: 'CDI' }
  },
  emits: ["on-period-filter-change", "on-benchmark-filter-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-period-filter-change', value: string): void;
  (e: 'on-benchmark-filter-change', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoading: boolean, hasError: boolean, chartSummary: IChartSummary, periodFilters: IProductPeriod[], benchmarkFilters: IProductBenchmark[], profitLabel: string, returnLabel: string };





const benchmarkReturn = computed(() => {
  return props.chartSummary?.benchmarkReturn || { value: 0, formatted: '0' };
});

const percentageValue = computed(() => {
  return props.chartSummary?.percentageValue || { value: 0, formatted: '0' };
});

const benchmarkComparison = computed(() => {
  return (
    props.chartSummary?.benchmarkComparison || { value: 0, formatted: '0' }
  );
});

const benchmarkLabel = computed(() => {
  if (!activeBenchmarkFilter.value.label) {
    return '% CDI';
  }

  const sign = activeBenchmarkFilter.value.label === 'CDI' ? '%' : '±';

  return `${sign} ${activeBenchmarkFilter.value.label}`;
});

const activePeriodFilter = computed(() => {
  const filter = props.periodFilters?.find(filter => filter.active);
  return {
    value: filter?.value || '',
    label: filter?.label || ''
  };
});

const activeBenchmarkFilter = computed(() => {
  const filter = props.benchmarkFilters?.find(filter => filter.active);
  return {
    value: filter?.value || '',
    label: filter?.label || ''
  };
});

const hasFilter = computed(() => {
  return props.benchmarkFilters?.length > 0 || props.periodFilters?.length > 0;
});

const emitPeriodFilterChange = (value: string) => {
  emit('on-period-filter-change', value);
};

const emitBenchmarkFilterChange = (value: string) => {
  emit('on-benchmark-filter-change', value);
};

return { __sfc: true,props, emit, benchmarkReturn, percentageValue, benchmarkComparison, benchmarkLabel, activePeriodFilter, activeBenchmarkFilter, hasFilter, emitPeriodFilterChange, emitBenchmarkFilterChange, Heading, FilterSelect, SkeletonLoader, SpinnerLoader, NebraskaColors, VerticalListDisplay }
}

})